import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  personObject: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/person/vuex/index.js